import { Box, Link, Typography } from '@mui/material';
import React, { useContext, useMemo } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import AuthContext from '../../store/auth-context';
import OlympicsContext from '../../store/olympics-context';
import { whatsNewPage } from '../../store/fixed-routing';

export type HelpLink = {
	label: string;
	url: string;
	roles: string[];
};

const HelpPage = () => {
	const { role } = useContext(AuthContext);
	const { olympics } = useContext(OlympicsContext);

	const helpIntro = olympics?.helpIntro ?? '';
	const helpLinks = (olympics?.helpLinks ?? []) as HelpLink[];

	const visibleLinks = useMemo(() => {
		if (!role) return [];
		return helpLinks.filter((link) => {
			const roles = link.roles?.length ? link.roles : ['teacher', 'secretary', 'administrator'];
			return roles.includes(role);
		});
	}, [helpLinks, role]);

	return (
		<Box sx={{ p: { xs: 2, sm: 0 }, maxWidth: 720, pb: 6 }}>
			<Typography
				variant='h5'
				sx={{ mb: 2 }}
			>
				Pomoc
			</Typography>
			{helpIntro ? (
				<Typography
					variant='body1'
					color='text.secondary'
					sx={{ mb: 3, whiteSpace: 'pre-wrap' }}
				>
					{helpIntro}
				</Typography>
			) : (
				<Typography
					variant='body1'
					color='text.secondary'
					sx={{ mb: 3 }}
				>
					Materiały pomocy dla pracy w panelu. Administrator może skonfigurować linki w Ustawieniach.
				</Typography>
			)}
			{visibleLinks.length === 0 ? (
				<Typography variant='body1'>Brak skonfigurowanych linków pomocy dla Twojej roli.</Typography>
			) : (
				<Box
					component='ul'
					sx={{ pl: 2, m: 0 }}
				>
					{visibleLinks.map((link) => (
						<Box
							component='li'
							key={`${link.label}-${link.url}`}
							sx={{ mb: 1 }}
						>
							<Link
								href={link.url}
								target='_blank'
								rel='noopener noreferrer'
							>
								{link.label}
							</Link>
						</Box>
					))}
				</Box>
			)}
			<Typography
				variant='body2'
				color='text.secondary'
				sx={{ mt: 4 }}
			>
				Aktualizacje panelu:{' '}
				<Link
					component={RouterLink}
					to={whatsNewPage}
				>
					Co nowego
				</Link>
			</Typography>
		</Box>
	);
};

export default HelpPage;
